import { Outlet } from "react-router-dom";
import Layout from "../components/layout/layout";

const UserLayout = () => {
  return (
    <>
      <Layout>
        <Outlet />
      </Layout>
    </>
  );
};

export default UserLayout;
